module.exports = __webpack_public_path__ + "img/1565026161.afd9e191.jpg";